import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button
} from 'reactstrap';

import CollapsingSection from '../../../shared/components/CollapsingSection';
import PhonePreview from '../../../shared/components/PhonePreview';
import ScrollWatcher from '../../../shared/components/ScrollWatcher';
import PaymentForm from '../../../shared/components/PaymentForm';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import CampaignPaymentForm from '../../GuidedCampaignReview/components/CampaignPaymentForm';

import CampaignOverview from './CampaignOverview';

import {
  getWindowHeight,
  formatPaymentMethod,
  delayPromiseChain
} from '../../../shared/utils';

const PAYMENT_SECTION = '__PAYMENT_SECTION__';

const CREATE_NEW_PAYMENT_METHOD_OPTION = '__CREATE_NEW_PAYMENT_METHOD_OPTION__';

const NAVBAR_HEIGHT = 72;

const MAXIMUM_PREVIEW_HEIGHT = 600;

class GuidedCampaignPayment extends Component {
  constructor(){
    super();

    this.state = {
      activePreviewEngagementId:'__FEED__',
      activeSection:null,
      previewIsFixed:false,
      stripeToken:null,
      isUsingExistingFunds:false,
      stripeValidationMessages:{}
    };
  }

  componentDidMount(){
    //TODO FIND A DECLARATIVE WAY OF DOING THIS
    console.log('')
    window.scrollTo(0,0);
    this.props.loadCampaign(this.props.campaignId)
      .then(() => Promise.all([
        this.props.loadAgency(this.props.activeCampaign.agencyId),
        this.props.loadPaymentMethodsForAgency(this.props.activeCampaign.agencyId),
        this.props.loadAccountHistory(this.props.activeCampaign.agencyId)
      ]))
      .then(() => {
        if(!this.props.activePaymentMethod.id){
          this.setState({activeSection:PAYMENT_SECTION})
        }
      });
  }

  handleScroll(top){
    if(top > (NAVBAR_HEIGHT - 10) && !this.state.previewIsFixed){
      this.setState({previewIsFixed:true});
    }

    if(top <= (NAVBAR_HEIGHT - 10) && this.state.previewIsFixed){
      this.setState({previewIsFixed:false});
    }
  }

  handleSubmit(data){
    if(data.paymentMethodId === CREATE_NEW_PAYMENT_METHOD_OPTION){
      this.props.createPaymentMethod({
        token:data.token,
        last4:data.last4,
        kind:data.kind,
        agencyId:this.props.activeCampaign.agencyId
      })
        .then((res) => {
          const paymentMethodId = res.instance.id;

          return Promise.all([
            this.props.updateCampaign(this.props.activeCampaign.id,{ paymentMethodId:paymentMethodId }),
            this.props.updateAgency(this.props.activeCampaign.agencyId,{ defaultPaymentMethodId:paymentMethodId })
          ])
        })
        .then(() => delayPromiseChain(1000))
        .then(() => this.setState({
          isSaving:false,
          activeSection:null
        }));
    } else {
      this.props.updateCampaign(this.props.activeCampaign.id,{paymentMethodId:data.paymentMethodId})
        .then(() => delayPromiseChain(1000))
        .then(() => this.setState({
          isSaving:false,
          activeSection:null
        }));      
    }

  }

  handleStripeTokenSubmit(token){
    const {
      createPaymentMethod,
      activeCampaign,
      updateCampaign,
      updateAgency
    } = this.props;

    createPaymentMethod({
      token:token.id,
      last4:token.card.last4,
      kind:'card',
      agencyId:activeCampaign.agencyId
    })
      .then((res) => {
        const paymentMethodId = res.instance.id;

        return Promise.all([
          updateCampaign(this.props.activeCampaign.id,{ paymentMethodId:paymentMethodId }),
          updateAgency(this.props.activeCampaign.agencyId,{ defaultPaymentMethodId:paymentMethodId })
        ])
      })
      .then(() => delayPromiseChain(1000))
      .then(() => this.setState({
        isSaving:false,
        isUsingExistingFunds:false,
        activeSection:null
      }));    
  }

  handleDefaultCreditCardSubmit(){
    const {
      activeAgencyPaymentMethod,
      activeCampaign,
      updateCampaign
    } = this.props;

    updateCampaign(activeCampaign.id,{ paymentMethodId:activeAgencyPaymentMethod.id })
      .then(() => this.setState({
        activeSection:null,
        isUsingExistingFunds:false
      }));
  }

  handleExistingFundsSubmit(){
    const {
      activeCampaign,
      updateCampaign
    } = this.props;

    this.setState({isSaving:true});

    updateCampaign(activeCampaign.id,{ paymentMethodId:'' })
      .then(() => this.setState({
        isUsingExistingFunds:true,
        isSaving:false,
        activeSection:null
      }));    
  }


  getPaymentSectionSubtitle(){
    const {
      agencyAccountingBalance,
      activePaymentMethod,
      activeCampaign
    } = this.props;

    const {
      isUsingExistingFunds
    } = this.state;

    if(isUsingExistingFunds){
      return (<span>Existing Funds: <MoneyDisplay>{agencyAccountingBalance}</MoneyDisplay></span>) 
    } else {
      return formatPaymentMethod(activePaymentMethod);
    }
  }

  handleBackClick(){
    this.props.history.push('/welcome/tutorial/'+this.props.campaignId+'/audience');
  }

  handleForwardClick(){
    this.props.history.push('/welcome/tutorial/'+this.props.campaignId+'/review');
  }

  render(){
    const {
      activeSection,
      activePreviewEngagementId,
      previewIsFixed,
      isUsingExistingFunds
    } = this.state;

    const {
      activeCampaign,
      activeBrand,
      activeAgency,
      activeEngagements,
      activePaymentMethod,
      activePaymentMethods,
      showSuperadminFeatures,
      agencyAccountingBalance
    } = this.props;

    const previewHeight = getWindowHeight() - 340;

    return (
      <div >
        <Row className='GuidedCampaignPayment'>
          <ScrollWatcher onScroll={(top) => this.handleScroll(top)} />
          <Col xs='8'>
            <br />
            <h3>Payment Method</h3>
            <Row>
              <Col xs='8'>
                <br />
                <br />
                <h5>How you pay</h5>
                <p>
                  You pay for this service only after you accrue costs, via an automatic charge when you reach your billing threshold or at the end of each month, whichever comes first.</p>
                <br />
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <CollapsingSection
                  open={activeSection ===  PAYMENT_SECTION}
                  onOpenClick={() => this.setState({activeSection:PAYMENT_SECTION})}
                  title='Payment method'
                  subtitle={this.getPaymentSectionSubtitle()}
                  titleWidthInColumns={4}
                >
                  <CampaignPaymentForm 
                    allowCreateNewMethod
                    showSuperadminFeature={false}
                    accountBalance={agencyAccountingBalance}
                    createFormOnly={activePaymentMethods.length === 0}
                    activePaymentMethodId={activeCampaign.paymentMethodId}
                    defaultPaymentMethodId={activeAgency.defaultPaymentMethodId}
                    existingPaymentMethods={activePaymentMethods}
                    showSuperadminFeatures={showSuperadminFeatures}
                    onSubmit={(data) => this.handleSubmit(data)}
                    onStripeTokenSubmit={(token) => this.handleStripeTokenSubmit(token)}
                    onDefaultCreditCardSubmit={() => this.handleDefaultCreditCardSubmit()}
                    onExistingFundsSubmit={() => this.handleExistingFundsSubmit()}
                  />
                </CollapsingSection>
                <br />
                <div>
                  <Button 
                    color="primary" 
                    onClick={() => this.handleForwardClick()}
                    disabled={(!activeCampaign.paymentMethodId || activeCampaign.paymentMethodId.length === 0) && !isUsingExistingFunds}
                  >
                    &nbsp;&nbsp;Next: review & submit&nbsp;&nbsp;
                  </Button>
                  &nbsp;&nbsp;
                  <Button 
                    color="primary" 
                    onClick={() => this.handleForwardClick()}
                  >
                    &nbsp;&nbsp;Add Later&nbsp;&nbsp;
                  </Button>  
                  &nbsp;&nbsp;
                  <Button onClick={() => this.handleBackClick()}>
                    &nbsp;&nbsp;Back&nbsp;&nbsp;
                  </Button>  
                </div>  
                <br />
                <br />       
              </Col>
            </Row>
          </Col>
          <Col xs='4'>
            <div
              style={{
                position:previewIsFixed ? 'fixed' : 'inherit',
                top:previewIsFixed ? 10 : 0,
                paddingTop:10,
                width:300
              }}
            >
              <PhonePreview
                hideTotalValue
                phonePlatform='generic'
                activeEngagementId={activePreviewEngagementId}
                engagements={activeEngagements}
                feedText={activeCampaign.feedText}
                feedImageURL={activeCampaign.feedImageURL}
                height={previewHeight > MAXIMUM_PREVIEW_HEIGHT ? MAXIMUM_PREVIEW_HEIGHT : previewHeight}
                brandName={activeBrand.name || 'your brand'}
                logoURL={activeBrand.logoURL}
                conclusionText={activeCampaign.completionText}
                conclusionBackgroundColor={activeBrand.primaryColor}
                cta={activeCampaign.useCTA ? {link: activeCampaign.ctaLink, color: activeCampaign.ctaColor, text: activeCampaign.ctaText} : null}
              />
              <br />
              <br />
              <CampaignOverview
                activeCampaign={activeCampaign}
                activeEngagements={activeEngagements}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

GuidedCampaignPayment.propTypes = {
  //TODO: Fill in prop types for GuidedCampaignPayment
};

GuidedCampaignPayment.defaultProps = {
  //TODO: Fill in defaultProps for GuidedCampaignPayment
};

export default GuidedCampaignPayment;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignPayment/components/GuidedCampaignPayment.js